import { styled } from 'styled-components'
import React, { useEffect } from 'react'
import { Button, Icon } from '@equinor/eds-core-react'
import { CardImageWrapper } from '@/components/styles/PortfolioStyles'

interface ISensorImage {
    imageSrc: string
    onClick: () => void
}

export const SensorImage: React.FC<ISensorImage> = ({ imageSrc, onClick }) => {
    const pathname = window.location.pathname
    const page = `${pathname.split('/')[1]}`

    const renderSensorImage = () => {
        switch (page) {
            case 'portfolio':
                return (
                    <CardImageWrapper data-card-action onClick={onClick}>
                        <img src={imageSrc} />
                    </CardImageWrapper>
                )
            case 'dashboard':
                return (
                    <SensorImageWrapper data-card-action onClick={onClick}>
                        <img src={imageSrc} />
                    </SensorImageWrapper>
                )
            default:
                return <></>
        }
    }

    return renderSensorImage()
}

interface ISensorImagePopup {
    imageSrc: string
    onClose: () => void
}

export const SensorImagePopup: React.FC<ISensorImagePopup> = ({ imageSrc, onClose }) => {
    const handleClickOutside = (event: MouseEvent) => {
        const cardImagePopup = document.getElementById('imagePopup')
        if (cardImagePopup && !cardImagePopup.contains(event.target as Node)) {
            onClose()
        }
    }

    const handleKeyDown = (event: KeyboardEvent) => {
        if (event.key === 'Escape') {
            onClose()
        }
    }

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside)
        document.addEventListener('keydown', handleKeyDown)
        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
            document.removeEventListener('keydown', handleKeyDown)
        }
    }, [])

    return (
        <PopupWrapper role="dialog" aria-modal="true">
            <PopupImageWrapper id="imagePopup">
                <CloseButton variant="ghost_icon" onClick={onClose} aria-label="Close image">
                    <Icon name="close" />
                </CloseButton>
                <img src={imageSrc} alt="Popup" />
            </PopupImageWrapper>
        </PopupWrapper>
    )
}

const SensorImageWrapper = styled.div`
    position: absolute;
    width: 100px;
    height: 100px;
    top: 0px;
    right: 0px;
    border-radius: 4px;
    //box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
    box-shadow: 0px 3px 4px 0px #0000001f;
    box-shadow: 0px 2px 4px 0px #00000024;
    background-color: #ffffff;
    cursor: 'pointer';

    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
`

const PopupWrapper = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
`

const PopupImageWrapper = styled.div`
    position: relative;
    background-color: white;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    max-width: min(90vw, 720px);
    max-height: 90vh;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
        display: block;
    }

    @media (max-width: 600px) {
        padding: 12px;
        border-radius: 4px;
        max-width: 95vw;
        max-height: 95vh;
    }
`

const CloseButton = styled(Button)`
    position: absolute;
    top: 8px;
    right: 8px;
    z-index: 1;
`
